// Helpers for the camera "Stream Source" / "Live Stream URL" fields
// (backend: Camera.stream_source + Camera.livestream_url, exposed via
// /camera/:id/general_info/). External URLs let sites whose integration
// can't natively stream (e.g. SMTP camera sites) provide a stream URL
// that the streaming stack pulls instead of the connector.

// Customer-facing labels: never say "connector" — customers don't know what
// that is. "Default" = video comes through the camera's normal integration.
export const STREAM_SOURCE_OPTIONS = [
  { name: "Default", value: "connector" },
  { name: "External URL", value: "external_url" },
];

export const getStreamSourceName = (value: string) => {
  const option = STREAM_SOURCE_OPTIONS.find(
    (object) => object.value === value
  );
  return option ? option.name : value;
};

export const LIVESTREAM_URL_ERROR_MESSAGE =
  "Live Stream URL must start with rtsp://, rtsps://, http://, or https://";

// URL must start with rtsp://, rtsps://, http://, or https://
export const isValidLivestreamUrl = (url: string) => {
  return /^(rtsps?|https?):\/\//i.test(url.trim());
};

// Mask the password portion of a URL containing userinfo credentials
// (e.g. rtsp://admin:secret@host/... -> rtsp://admin:•••@host/...).
// URLs without a user:pass@ segment are returned unchanged.
export const maskLivestreamUrlPassword = (url: string) => {
  return url.replace(
    /^([a-z][a-z0-9+.-]*:\/\/[^:@/?#]+:)([^@/?#]+)(?=@)/i,
    "$1•••"
  );
};
